import {
    SET_DRIVE_TRAIN,
} from "./DriveTrainType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_DRIVE_TRAIN:
            return {
                ...state,
                driveTrainDropDown: action.driveTrainList,
            };
        default:
            return state;
    }
};

export default reducer;
